import { Link } from 'react-router-dom'

const Footer = () => {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="border-t border-[var(--line-100)] bg-white">
      <div className="container-shell py-10 sm:py-12">
        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
          <div className="space-y-3">
            <p className="text-sm font-semibold uppercase tracking-[0.11em] text-ink-500">Asterode</p>
            <p className="max-w-xs text-sm leading-relaxed text-ink-600">
            Asterode is a modern iOS and Android application for productivity that brings top AI models, notes, and memory into one place.
            </p>
            <p className="text-sm text-ink-600">
              Project by <span className="font-semibold text-ink-800">Stef Buzas</span>.
            </p>
          </div>

          <div className="space-y-3">
            <p className="text-sm font-semibold uppercase tracking-[0.11em] text-ink-500">Information</p>
            <div className="space-y-2 text-sm text-ink-600">
              <Link to="/app-privacy" className="block transition hover:text-ink-500">
                App Privacy
              </Link>
              <Link to="/app-terms" className="block transition hover:text-ink-500">
                App Terms
              </Link>
              <Link to="/app-delete" className="block transition hover:text-ink-500">
                Delete App Data
              </Link>
              <a href="mailto:support@asterode.ai" className="block transition hover:text-ink-500">
                support@asterode.ai
              </a>
            </div>
          </div>

          <div className="space-y-3">
            <p className="text-sm font-semibold uppercase tracking-[0.11em] text-ink-500">Other Projects</p>
            <div className="space-y-2 text-sm text-ink-600">
              <a href="https://triedbystef.com" target="_blank" rel="noopener" className="block transition hover:text-ink-500">
                Tried by Stef - Product Reviews for SEO
              </a>
              <a href="https://hiraku.ai" target="_blank" rel="noopener" className="block transition hover:text-ink-500">
                Hiraku - Open Source Components
              </a>
              <a href="https://stefbuzas.com" target="_blank" rel="noopener" className="block transition hover:text-ink-500">
                Stef Buzas - Portfolio and Contact
              </a>
            </div>
          </div>
        </div>

        <div className="mt-8 border-t border-[var(--line-100)] pt-5 text-sm text-ink-500">
          <p>&copy; {currentYear} Asterode. All rights reserved.</p>
        </div>
      </div>
    </footer>
  )
}

export default Footer


